import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Input } from '@/components/ui/input'

interface ColorFieldProps {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
}

export const ColorField = ({ field, value, onChange }: ColorFieldProps) => {
  return (
    <div className="flex gap-3">
      <div className="relative h-12 w-12 shrink-0 rounded-lg border overflow-hidden">
        <Input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="absolute inset-0 w-[200%] h-[200%] -translate-x-1/4 -translate-y-1/4 cursor-pointer"
        />
      </div>
      <Input
        value={value || '#000000'}
        onChange={(e) => onChange(e.target.value)}
        className="h-12 font-mono"
      />
    </div>
  )
}
